import { createApp } from 'vue'
import { clerkPlugin } from '@clerk/vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)
const publishableKey = process.env.VUE_APP_CLERK_PUBLISHABLE_KEY

if (publishableKey) {
  app.use(clerkPlugin, { publishableKey })
}

app.use(router).mount('#app')
